const NOT_INITIALIZE = '000'
const PENDING_BOTH_PARENTS = '001'
const APPROVED_ONLY_PARENT_1 = '002'
const APPROVED_ONLY_PARENT_2 = '003'
const APPROVED = '004'

export default {
  NOT_INITIALIZE,
  PENDING_BOTH_PARENTS,
  APPROVED_ONLY_PARENT_1,
  APPROVED_ONLY_PARENT_2,
  APPROVED
}
